import { useEffect, useState } from "react";
import { useLenis } from "@/hooks/useLenis";
import { api } from "@/lib/api";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Manifesto from "@/components/site/Manifesto";
import Catalogue from "@/components/site/Catalogue";
import Gallery from "@/components/site/Gallery";
import Occasions from "@/components/site/Occasions";
import Availability from "@/components/site/Availability";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Loader from "@/components/site/Loader";

const Home = () => {
    useLenis();
    const [settings, setSettings] = useState(null);
    const [products, setProducts] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const [s, p, t, g] = await Promise.all([
                    api.get("/settings"),
                    api.get("/products"),
                    api.get("/testimonials"),
                    api.get("/gallery"),
                ]);
                if (!alive) return;
                setSettings(s.data);
                setProducts(p.data);
                setTestimonials(t.data);
                setGallery(g.data);
            } catch (_e) {
                /* keep defaults */
            } finally {
                // small min-time for the wow-moment loader
                setTimeout(() => alive && setLoading(false), 1400);
            }
        })();
        return () => {
            alive = false;
        };
    }, []);

    return (
        <div className="App relative">
            <Loader show={loading} />
            <Header />
            <main>
                <Hero settings={settings} />
                <EditorialMarquee />
                <Manifesto />
                <Catalogue products={products} />
                <Gallery items={gallery} />
                <Occasions />
                <Availability products={products} />
                <Testimonials testimonials={testimonials} />
                <Contact settings={settings} />
            </main>
            <Footer settings={settings} />
        </div>
    );
};

export default Home;
